import React from 'react';
import '../style/notifications.css';
import moment from "moment";
import { sanitizeInfoText } from '../helpers/commentParser';
import { FormGroup, HorizontalRule, Link } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';
import { DOTTED, LEFT, PRIMARY, NOTIFICATION_TYPE_MN_COMMENT_NEW_APPLICATION } from '../helpers/constants';
import CONTENT_STRINGS from '../helpers/contentStrings';

const Notification = (props) => {

	const {
		item,
		getNotificationStatusText,
		onNotificationClick,
		index
	} = props;

	const dateString = moment(item.createdAt).format('DD/MM/YYYY');
	const notificationItemLabel = `${dateString} | ${item.solicitorFileReference} - ${item.customerName} | (ARAG ID: ${item.aragId}) | ${getNotificationStatusText(item)}`;
	const isNewApplicationComment = item.comment === NOTIFICATION_TYPE_MN_COMMENT_NEW_APPLICATION;
	const notificationItemValue = isNewApplicationComment ? item.comment : item.eventName;
	const notificationComment = isNewApplicationComment ? null : sanitizeInfoText(item.comment);
	const handleNotificationClick = () => onNotificationClick(item);
	return(
		<div className="row applicationsAndPolicies-wrapper">
			<div className="col-sm-12">
				<div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
					<FormGroup
						labelSize={'col-sm-12'}
						inputSize={''}
						label={<>{notificationItemLabel} | <strong>{notificationItemValue}</strong> {notificationComment}</> }
						variant={FORM_GROUP_VARIANTS.PLAIN}
						inputProps={{
							id: `notificationItem_${item.id}`,
							name: `notificationItem_${item.id}`,
						}}
						formGroupTestId={`notifications-notification-${index}-identifier`}
					/>
					<Link
						label={CONTENT_STRINGS.TAKE_ACTION}
						onClick={handleNotificationClick}
						arrowDirection={LEFT}
						variant={PRIMARY}
						linkTestId={`notifications-notification-${index}-take-action`}
					/>
				</div>
				<HorizontalRule variant={DOTTED} />
			</div>
		</div>
	);

};
export default Notification;
